import { render } from "./Works.vue?vue&type=template&id=4e785b2c&scoped=true"
import script from "./Works.vue?vue&type=script&lang=js"
export * from "./Works.vue?vue&type=script&lang=js"

import "./Works.vue?vue&type=style&index=0&id=4e785b2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e785b2c"

export default script